import { render, staticRenderFns } from "./paperCheck.vue?vue&type=template&id=01f570a6&scoped=true&"
import script from "./paperCheck.vue?vue&type=script&lang=js&"
export * from "./paperCheck.vue?vue&type=script&lang=js&"
import style0 from "./paperCheck.vue?vue&type=style&index=0&id=01f570a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f570a6",
  null
  
)

export default component.exports